/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
// eslint-disable-next-line no-unused-vars
import { PublicClientApplication } from '@azure/msal-browser';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal, Label,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import * as url from '../../helpers/url_helper';
import { post } from '../../helpers/api_helper';

function PicklistGenerateModal(props) {
  const {
    shown,
    t,
    onClose,
  } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 8000,
  };

  const user = JSON.parse(localStorage.getItem('authUser'));

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [shown]);

  // eslint-disable-next-line no-unused-vars
  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const generate = async (e) => {
    e.preventDefault();

    try {
      const result = await post('/api/orders/picklist/generate', {
        route_type: e.target.route_type.value,
        max_orders: e.target.quantity.value,
      });

      if (result.success) toastr.success('Picklist generated', 'Success');
      if (!result.success) toastr.warning(t('No available orders!'), t('Notice'));
      onSuccess();
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const jsx = (
    <Modal
      size="md"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
        >
          {t('Generate Picklist')}
        </h5>
        <button
          onClick={() => { setModalOpen(false); onClose(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <form id="GenerateForm" onSubmit={generate}>
          <div className="mt-3 mb-3">
            <Label for="route_type">{t('Route Type')}</Label>
            <select id="route_type" name="route_type" className="form-control">
              <option value="mande">{t('M&E')}</option>
              <option value="single-piece">{t('Single-Piece Orders')}</option>
              <option value="multi-piece">{t('Multi-Piece Orders')}</option>
            </select>
          </div>

          <div className="mb-3 mt-3">
            <Label
              for="quantity"
            >
              {t('Max Orders')}
            </Label>
            <input
              className="form-control"
              type="number"
              step="1"
              max="40"
              value="40"
              min="1"
              id="quantity"
              name="quantity"
            />
          </div>
        </form>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { setModalOpen(false); onClose(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="GenerateForm"
          className="btn btn-primary"
        >
          {t('Generate')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

PicklistGenerateModal.defaultProps = {
  shown: false,
  onSuccess: () => { },
  onClose: () => { },
};

PicklistGenerateModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(PicklistGenerateModal));
